import { violationWarn } from '@/api/domain/carsService.js'
import { MessageBox } from '@qs/ui'
import router from '@/router'

export const useViolationWarnAlert = async () => {
  const COOKIE_NAME = 'violation_warn_shown_12h'
  if (document.cookie.split('; ').find((row) => row.startsWith(`${COOKIE_NAME}=`))) {
    return
  }

  const { code, data } = await violationWarn({
    warnType: 10, // 10: 合同变更告警 11: 操作异常告警
  })
  if (code === 1 && data.warnMsg) {
    // 设置12小时过期的cookie (max-age 单位为秒，避免时区差异)
    document.cookie = `${COOKIE_NAME}=true; max-age=${12 * 60 * 60}; path=/`

    let messageContent = `<div><p>${data.warnMsg}</p>`

    if (data.companyNameList?.length > 0) {
      const fullCompanyNames = data.companyNameList.join('、')
      const maxLength = 20 // 设置最大显示字符数

      if (fullCompanyNames.length > maxLength) {
        const truncatedNames = `${fullCompanyNames.substring(0, maxLength)}...`
        messageContent += `
          <p style="margin-top: 10px;">
            公司名称：
            <span title="${fullCompanyNames}" 
            >
              ${truncatedNames}
            </span>
          </p>
        `
      } else {
        messageContent += `<p style="margin-top: 10px;">公司名称：${fullCompanyNames}</p>`
      }
    }

    messageContent += '</div>'

    MessageBox.alert(messageContent, '提示', {
      confirmButtonText: '去扫码',
      dangerouslyUseHTMLString: true,
    }).then(() => {
      router.push({
        name: 'vehicle_violation_query_record',
        params: {
          invokeScan: true,
        },
      })
    }).catch(() => null)
  }
}
